"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheImpl = void 0;
class CacheImpl {
    constructor(cache) {
        this.after = async (isOffline, getRequest, afterId, withMemberId) => {
            if (isOffline) {
                const messages = await this.fromCache(withMemberId);
                if (messages !== null) {
                    if (afterId) {
                        const indexOfMessageAfter = messages.indexOf(messages.find((message) => message.message.id === afterId)) + 1;
                        return messages.slice(indexOfMessageAfter);
                    }
                    return messages;
                }
            }
            const messagesFromBackend = await getRequest();
            await this.toCache(messagesFromBackend, withMemberId);
            return messagesFromBackend;
        };
        this.before = async (_isOffline, getRequest, beforeId, withMemberId) => {
            const messages = (await this.fromCache(withMemberId)) || [];
            const indexOfMessageBefore = messages.indexOf(messages.find((message) => message.message.id === beforeId));
            if (indexOfMessageBefore > 0) {
                return messages.slice(0, indexOfMessageBefore);
            }
            const messagesFromBackend = await getRequest();
            if (messagesFromBackend.length === 11) {
                const messagesFromBackendCopy = [...messagesFromBackend];
                messagesFromBackendCopy.shift();
                const toCacheMessages = [...messagesFromBackendCopy, ...messages];
                await this.toCache(toCacheMessages, withMemberId);
            }
            else {
                const toCacheMessages = [...messagesFromBackend, ...messages];
                await this.toCache(toCacheMessages, withMemberId);
            }
            return messagesFromBackend;
        };
        this.fromCache = async (withMemberId) => {
            return (await this.cache
                .getArray(`ChatCacheImpl.v3.MESSAGES.${withMemberId}`)
                .withDefault(null)
                .asPromise());
        };
        this.toCache = async (toCacheMessages, withMemberId) => {
            await this.cache.setArray(`ChatCacheImpl.v3.MESSAGES.${withMemberId}`, toCacheMessages);
        };
        this.push = async (message, toMemberId) => {
            const messages = (await this.fromCache(toMemberId)) || [];
            messages.push(message);
            await this.toCache(messages, toMemberId);
        };
        this.cache = cache;
    }
}
exports.CacheImpl = CacheImpl;
//# sourceMappingURL=Cache.js.map